<template>
  <div class="common-page order-review">
    <div class="left-box-content">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="下单时间:">
                <custom-date-range
                  :start-date="searchForm.startTime"
                  :end-date="searchForm.endTime"
                  @update:startDate="(val) => (searchForm.startTime = val)"
                  @update:endDate="(val) => (searchForm.endTime = val)"
                ></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单来源:" prop="orderSource">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.orderSourceOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="装货地:" prop="deptIds">
                <el-cascader
                  style="width: 100%"
                  v-model="searchForm.deptIds"
                  :options="deptList"
                  clearable
                  :show-all-levels="false"
                  :props="{
                    checkStrictly: true,
                    value: 'deptId',
                    label: 'deptName',
                  }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="卸货地:" prop="deptIds">
                <el-cascader
                  style="width: 100%"
                  v-model="searchForm.deptIds"
                  :options="deptList"
                  clearable
                  :show-all-levels="false"
                  :props="{
                    checkStrictly: true,
                    value: 'deptId',
                    label: 'deptName',
                  }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button
                  type="primary"
                  round
                  icon="el-icon-search"
                  @click="handleCheck()"
                ></el-button>
                <el-button
                  type="default"
                  round
                  icon="el-icon-refresh"
                  @click="handleReset()"
                ></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div
        class="custom-table-box"
        v-loading="tableOptions.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.8)"
      >
        <div
          class="table-list"
          :class="item.userId === selectOrderId ? 'table-list-select' : ''"
          v-for="(item, index) in 10"
          :key="item.userId"
          @click="handleSelectOrder(item, index)"
        >
          <div class="list-top">
            <div class="list-top-left">
              <div class="left-box">
                <div class="left-box-top">
                  <div class="label zhuang">装</div>
                  <div class="name">南京玄武区</div>
                </div>
                <div class="date">02-24 10:30-11:00</div>
              </div>
              <div class="left-box">
                <div class="left-box-top">
                  <div class="label zhuang">装</div>
                  <div class="name">南京玄武区</div>
                </div>
                <div class="date">02-24 10:30-11:00</div>
              </div>
              <div class="left-box">
                <div class="left-box-top">
                  <div class="label xie">卸</div>
                  <div class="name">南京玄武区</div>
                </div>
                <div class="date">02-24 10:30-11:00</div>
              </div>
            </div>
            <div class="list-top-right">
              <div class="right-money">
                <span class="money">3000.00</span>
                <span class="unit">元/趟</span>
              </div>
              <div class="right-box2">
                <div class="right-box2-time">02-09 12:30</div>
                <div><span class="sty1">客户代下单</span></div>
                <!--                <div><span class="sty2">散客下单</span></div>-->
              </div>
            </div>
          </div>
          <div class="list-bottom">
            <div class="list-bottom-box">
              <div class="bottom-box-name">订单归属</div>
              <div class="bottom-box-value">渠道商A</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">物品</div>
              <div class="bottom-box-value">门窗</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">重量</div>
              <div class="bottom-box-value">20吨</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">体积</div>
              <div class="bottom-box-value">2㎡</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">包装方式</div>
              <div class="bottom-box-value">吨包</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">用车要求</div>
              <div class="bottom-box-value">整车</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">车型</div>
              <div class="bottom-box-value">厢式货车</div>
            </div>
            <div class="list-bottom-box">
              <div class="bottom-box-name">车长</div>
              <div class="bottom-box-value">9.6米</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleSizeChange"
          :current-page="tableOptions.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="tableOptions.pageSize"
          background
          layout="total, prev, pager, next, sizes, jumper"
          :total="tableOptions.total"
        />
      </div>
    </div>
    <div class="line-separate"></div>
    <div class="right-box">
      <div class="right-top">
        <div class="right-title">指派给调度</div>
        <el-input
          class="right-search"
          style="width: 100%"
          clearable
          v-model="searchForm.keyword"
          autocomplete="off"
          suffix-icon="el-icon-search"
          placeholder="请输入调度姓名或手机号码"
        ></el-input>
      </div>
      <div class="right-center-box">
        <div
          class="center-box"
          v-for="(item, index) in userList"
          :key="item.id"
          :class="item.id === selectUserId ? 'selectTab' : ''"
          @click="handleClick(item, index)"
        >
          <div class="center-box-1">
            <span class="label-name">王</span>
            <span class="center-name">{{ item.name }}</span>
          </div>
          <div class="center-box-2">
            <i class="el-icon-phone"></i>
            <span>{{ item.phone }}</span>
          </div>
          <div class="center-box-3">
            <i
              class="el-icon-success"
              :class="
                item.id === selectUserId ? 'selected-icon' : 'default-icon'
              "
            ></i>
          </div>
        </div>
      </div>
      <div class="right-bottom-operate">
        <el-button type="default" @click="handleReset()">取消</el-button>
        <el-button type="primary" @click="handleCheck()">确定指派</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { downloadTable, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getTree } from "@/views/commonApi";

export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      searchForm: {
        keyword: "",
        startTime: "",
        terminalType: "1",
        deptId: "",
        deptIds: [],
        endTime: "",
        sourceType: "1",
      },
      userList: [
        {
          id: 1,
          name: "王大发",
          phone: "0123456789",
          selected: false,
        },
        {
          id: 2,
          name: "王小发",
          phone: "15928585003",
          selected: true,
        },
        {
          id: 3,
          name: "王小发",
          phone: "15928585006",
          selected: false,
        },
        {
          id: 4,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 5,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 6,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 7,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 8,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
        {
          id: 9,
          name: "王小发",
          phone: "15928585004",
          selected: false,
        },
      ], // 调度人员列表
      deptList: [],
      isImmediatelyGetData: true,
      selectOrderId: "",
      selectUserId: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    getTree() {
      getTree().then((res) => {
        if (res.code === 200) {
          this.deptList = res.data;
        }
      });
    },
    handleClick(item, index) {
      this.selectUserId = item.id;
    },
    handleSelectOrder(item, index) {
      this.selectOrderId = item.userId;
    },
  },
};
</script>
<style lang="scss" scoped>
.order-review {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: row;

  .left-box-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .custom-table-box {
      padding-top: 0;
      overflow-y: auto;
      .table-list {
        width: 100%;
        background: #fbfcff;
        margin-bottom: 0.2rem;
        padding: 0.12rem 0.1rem;
        box-sizing: border-box;
        border: 0.01rem solid #fbfcff;
        border-radius: 0.08rem;
        cursor: pointer;
        .list-top {
          display: flex;
          justify-content: space-between;
          .list-top-left {
            display: flex;
            .left-box {
              padding-right: 0.5rem;
              position: relative;
              .left-box-top {
                display: flex;
                align-items: center;
                .label {
                  width: 0.2rem;
                  height: 0.2rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 0.02rem;
                  font-size: 0.12rem;
                }
                .zhuang {
                  color: #5cc41a;
                  background-color: rgba(92, 196, 26, 0.3);
                }
                .xie {
                  color: #e52019;
                  background-color: rgba(229, 32, 25, 0.3);
                }
                .name {
                  color: #000000;
                  font-size: 0.18rem;
                  line-height: 0.2rem;
                  padding-left: 0.04rem;
                }
              }
              .date {
                color: #8c8c8c;
                font-size: 0.12rem;
                line-height: 0.2rem;
              }
            }
            .left-box::before {
              content: "→";
              position: absolute;
              right: 0.15rem;
              top: 0.04rem;
              color: #52c41a;
            }
            .left-box:nth-last-of-type(1)::before {
              display: none;
            }
          }
          .list-top-right {
            .right-money {
              display: flex;
              justify-content: right;
              align-items: baseline;
              color: #faad14;
              .money {
                font-size: 0.18rem;
              }
              .unit {
                font-size: 0.12rem;
                padding-left: 0.04rem;
              }
            }
            .right-box2 {
              display: flex;
              align-items: center;
              .right-box2-time {
                font-size: 0.12rem;
                line-height: 0.2rem;
                color: #8c8c8c;
                margin-right: 0.1rem;
              }
              .right-box2-label {
                background-color: #fff7e6;
                color: #fa8c16;
                font-size: 0.12rem;
                line-height: 0.22rem;
                border-radius: 0.1rem;
                padding: 0 0.1rem;
              }
            }
          }
        }
        .list-bottom {
          width: 100%;
          display: flex;
          padding: 0.12rem 0;
          .list-bottom-box {
            width: 15%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .bottom-box-name {
              color: #8c8c8c;
              font-size: 0.12rem;
              margin-bottom: 0.1rem;
            }
            .bottom-box-value {
              color: #434343;
              font-size: 0.14rem;
            }
          }
          .list-bottom-box::before {
            content: "";
            position: absolute;
            right: 0;
            top: 0.08rem;
            width: 0.01rem;
            height: 0.26rem;
            background-color: #dce5f5;
          }
          .list-bottom-box:nth-last-of-type(1)::before {
            display: none;
          }
        }
      }
      .table-list-select {
        border-color: #1269ff;
        background-color: rgba(18, 105, 255, 0.05);
      }
    }
    .pagination-box {
      display: flex;
      justify-content: right;
      background-color: #ffffff;
      padding: 0.2rem 0.2rem 0.2rem 0;
    }
  }
  .line-separate {
    width: 0.01rem;
    height: calc(100% - 0.4rem);
    background-color: rgba(220, 229, 245, 0.5);
    box-sizing: border-box;
    margin: 0.2rem 0.2rem 0.2rem 0;
  }
  .right-box {
    width: 26%;
    height: 100%;
    flex-shrink: 0;

    display: flex;
    flex-direction: column;
    padding-right: 0.2rem;
    box-sizing: border-box;
    .right-top {
      height: 1rem;
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      .right-title {
        padding: 0.2rem 0 0;
      }
      .right-search {
        margin: 0.2rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;

      .center-box {
        width: 100%;
        height: 0.64rem;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        padding: 0 0.1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        .center-box-1 {
          display: flex;
          align-items: center;
          width: 30%;
          .label-name {
            width: 0.24rem;
            height: 0.24rem;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #1269ff;
            font-size: 0.12rem;
            background-color: rgba(18, 105, 255, 0.05);
          }
          .center-name {
            line-height: 0.2rem;
            padding-left: 0.04rem;
          }
        }
        .center-box-2 {
          display: flex;
          align-items: center;
          line-height: 0.2rem;
          color: #8c8c8c;
          font-size: 0.12rem;
          .el-icon-phone {
            font-size: 0.1rem;
            margin-right: 0.02rem;
          }
        }
        .center-box-3 {
          line-height: 0.2rem;
          font-size: 0.16rem;
          .default-icon {
            color: #eeeeee;
          }
          .selected-icon {
            color: #52c41a;
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
      }
    }
    .right-bottom-operate {
      width: 100%;
      flex-shrink: 0;
      position: sticky;
      bottom: 0rem;
      background-color: #ffffff;
      display: flex;
      justify-content: right;
      padding: 0.15rem 0;
      box-sizing: border-box;
      border-top: 0.01rem solid #e3e7ed;
    }
  }
}
</style>
